<template>
  <div id="nav">
    <router-link :to="{ name: 'WorkflowHome'}" class="box">Workflow</router-link>
    <router-link :to="{ name: 'WorkflowCricketSchedule'}" class="box">Schedule</router-link>
    <a :href="'https://console.sports.roanuz.com/app/view/'+ appKey" class="box go-back-btn" title="console">Console</a>
  </div>
</template>

<script>
import CookieManager from '@/helpers/cookiemanager'
export default {
  name: 'Menu',
  data () {
    return {
      appKey: CookieManager.getItem('rzForAppkey')
    }
  },
  mounted () {
  }
}
</script>
